import {platformAPI} from "../../../api/axiosConfig";
import {Contact} from "../typedefs";
import {useQuery} from "react-query";

async function fetchContact(id: string | undefined): Promise<Contact | null> {
    if (!id) return null;
    const res = await platformAPI.get<Contact>(`api/contacts/${id}`);
    return res.data;
}

export function useGetContact(id: string | undefined) {
    const {data, isLoading, error, refetch} = useQuery(
        ["contact", id],
        () => fetchContact(id),
        {enabled: !!id, cacheTime: 0, refetchOnMount: true},
    );

    return {data, isLoading, error, refetch};
}
